const preload_assets = {
    glbUrls: {
        top_paddle: '/3dmodels/top-paddle.glb',
        portfolio_assets: '/3dmodels/portfolio-assets.glb',
        envelope: '/3dmodels/envelope.glb',
        cloud: '/3dmodels/cloud.glb',
        cacharro_switch: '/3dmodels/cacharros/switch.glb',
        cacharro_mobile: '/3dmodels/cacharros/mobile.glb',
        cacharro_laptop: '/3dmodels/cacharros/laptop.glb',
    },
    textures: {
        smile: '/textures/smile.jpg',
        surprise: '/textures/surprise.jpg',
        dizzy: '/textures/dizzy.jpg',
        winky: '/textures/winky.jpg',
        gradient3: '/textures/gradients/3.jpg',
    },
    fonts: {
        bellota: '/fonts/Bellota-Regular.ttf',
        bellota_light: '/fonts/Bellota-Light.ttf',
        lexend_deca: '/fonts/LexendDeca-VariableFont_wght.ttf',
    },
    // audio: [...],
    videos: {
        visual_experiments: '/media/visual-experiments-hb.mp4',
        creative_coding: '/media/creative-coding-hb.mp4',
        trooops: '/media/trooops-hb.mp4',
        clevercowboys: '/media/clevercowboys-hb.mp4',
        digdeep: '/media/digdeep-hb.mp4',
        freelance_gamedev: '/media/freelance-gamedev-hb.mp4',
        artists: '/media/artists-hb.mp4',
        spaceducks: '/media/spaceducks-hb.mp4',
        preludium: '/media/preludium-hb.mp4',
        kaleidos: '/media/kaleidos-hb.mp4',
        gamejams_popurri: '/media/gamejams-popurri-hb.mp4',
    },
}

const bio = {
    presentation: {
        web_title_normal: `FernanDog | Game Programmer, Creative Developer`,
        web_title_with_dog: `Fernan🐶 | Game Programmer, Creative Developer`,
        name_normal: `Fernando<span style="margin-left: 0.08em">G</span>`,
        name_with_dog: `Fernan<span class="header-dog-emoji">🐶</span>`,
        firstPart_complete: `I'm Fernando G, a freelance creative developer and game programmer and this is my three.js 3D portfolio.`,
        firstPart: `Hi! I'm a`,
        // similar to largest word in the roles
        emptyPart: `.........................................`,
        secondPart: `based in Barcelona.`
    },
    roles: [
        // slightly smaller fonts size to match the other roles width
        { role: `<span style="font-size: 0.9em">Freelance Developer</span>` },
        { role: `<span style="font-size: 1.0em">Game Developer</span>` },
        { role: `<span style="font-size: 0.9em">Creative Developer</span>` },
        { role: `<span style="font-size: 1.0em">Technical Artist</span>` },
        { role: `<span style="font-size: 1.0em">Event Organizer</span>` },
        { role: `<span style="font-size: 1.0em">Amateur Trapezist</span>` },
        { role: `<span style="font-size: 1.0em">Weird Films Lover</span>` },
    ],
    description: `I've been working with companies and as a freelance developer for more than 15 years.<br />
    Passionate about making personal and commercial games, exploring creative coding experiments and trying new technologies and tools. Always open to exciting new projects. If you've got a cool idea or opportunity, let's talk!`
}

const experiences = [
    {
        // 🟡: repasar el texto y video
        video_key: `creative_coding`,
        cacharro_type: `cacharro_switch`,
        media_url: preload_assets.videos.creative_coding,
        title: `Creative coding`,
        description: `Shaders, realtime compute shaders, and other creative coding techniques.`,
        tags: [`Compute Shaders`, `Shaders`, `Shadergraph`],
        links: []
    },
    {
        // 🟡: repasar el texto y video
        video_key: `visual_experiments`,
        cacharro_type: `cacharro_laptop`,
        media_url: preload_assets.videos.visual_experiments,
        title: `Visual programming experiments`,
        description: `Experiments with visual coding techniques and tools.`,
        tags: [`Procedural Animation`, `OpenCV`, `Blender Scripting`, `Three.js`],
        links: []
    },
    {
        // 🟡: repasar el texto y video
        video_key: `trooops`,
        cacharro_type: `cacharro_laptop`,
        media_url: preload_assets.videos.trooops,
        title: `TROOOPS`,
        description: `Steam game in development made in Godot.<br />TROOOPS is a tactical remake of the match-3 genre in an explosive fusion with deckbuilder, Candy Crush meets Slay the Spire and Balatro. Command chaotic troops into lethal squads and crush the enemy!`,
        tags: [`Indie Dev`, `Steam`, `Roguelike`, `Deckbuilder`, `Godot`],
        links: [
            {
                type: `youtube`,
                url: `https://www.youtube.com/watch?v=8Kq876RMqc0`
            }
        ]
    },
    {
        // 🟡: repasar el texto y video
        video_key: `digdeep`,
        cacharro_type: `cacharro_mobile`,
        media_url: preload_assets.videos.digdeep,
        title: `DigDeep!`,
        description: `Infinite runner mobile game made in C++. Join Roger and his squad on a intergalactic mining adventure`,
        tags: [`Indie Dev`, `Mobile Games`, `Infinite Runner`, `Cocos2d-x`, `C++`],
        links: [
            {
                type: `iOS`,
                url: `https://apps.apple.com/us/app/dig-deep/id1033679736`
            },
            {
                type: `itch.io`,
                url: `https://franfox.itch.io/dig-deep`
            }
        ]
    },
    {
        // 🟡: repasar el texto y video
        video_key: `clevercowboys`,
        cacharro_type: `cacharro_laptop`,
        media_url: preload_assets.videos.clevercowboys,
        title: `Clever Cowboys Never Ever Bite That Cactus`,
        description: `A short read&ride ALT-CTRL psychodelic vegan terror experience made in Unity with a bunch of cool shaders which is controlled by tying ropes to your gamepad.`,
        tags: [`Psychodelic`, `ALT-CTRL`, `Technical Art`, `Shaders`, `Unity`],
        links: [
            {
                type: `itch.io`,
                url: `https://drnlab.itch.io/clever-cowboys-never-ever-bite-that-cactus`
            }
        ]
    },
    {
        // 🟡
        video_key: `freelance_gamedev`,
        cacharro_type: `cacharro_laptop`,
        media_url: preload_assets.videos.freelance_gamedev,
        title: `Freelancing game development`,
        description: `Some of the games I've worked on as a freelancer from implementing game mechanics to game porting to consoles.`,
        tags: [`Unity`, `Game Mechanics`, `Porting`, `Xbox`],
        links: [
            {
                type: `Frank and Drake`,
                url: `https://store.steampowered.com/app/1530800/Frank_and_Drake/`
            },
            {
                type: `STAY`,
                url: `https://store.steampowered.com/app/753230/STAY/`
            }
        ]
    },
    {
        // 🟡: repasar el texto y video
        video_key: `artists`,
        cacharro_type: `cacharro_switch`,
        media_url: preload_assets.videos.artists,
        title: `Artists & Colors`,
        description: `Switch cute game made for children in Unity and ported by me to Switch. Interactive book for kids to learn colors and artists.`,
        tags: [`Indie Dev`, `Interactive Book`, `Porting`, `Switch`, `Unity`],
        links: [
            {
                type: `the artist`,
                url: `https://www.instagram.com/martuka_art/`
            },
            {
                type: `switch`,
                url: `https://www.nintendo.com/us/store/products/the-artist-colors-switch/`
            }
        ]
    },
    {
        // 🟡: repasar el texto y video
        video_key: `spaceducks`,
        cacharro_type: `cacharro_switch`,
        media_url: preload_assets.videos.spaceducks,
        title: `SpaceDucks`,
        description: `Steam game developed with a colleague in Godot and ported to Switch.<br />Cosmic puzzle adventure to help a lost tribe of duck-people in their millennial quest for a stable world. `,
        tags: [`Indie Dev`, `Godot`, `Porting`, `Steam`, `Switch`],
        links: [
            {
                type: `switch`,
                url: `https://www.nintendo.com/us/store/products/space-ducks-the-great-escape-switch/`
            },
            {
                type: `steam`,
                url: `https://store.steampowered.com/app/1862710/Space_Ducks_The_great_escape/`
            },
            {
                type: `itch.io`,
                url: `https://6toad.itch.io/space-ducks-the-great-escape`
            }
        ]
    },
    {
        // 🟡: repasar el texto y video
        video_key: `preludium`,
        cacharro_type: `cacharro_laptop`,
        media_url: preload_assets.videos.preludium,
        title: `preludium`,
        description: `Godot game template to make it easier to bootstrap new games with some good practices and common features like load scene manager, CI, tests, UI theme, etc.`,
        tags: [`Tooling`, `Godot`, `Game Template`, `Open Source`],
        links: [
            {
                type: `github`,
                url: `https://github.com/fernandogcat/preludium`
            }
        ]
    },
    {
        // 🟡: repasar el texto y video
        video_key: `kaleidos`,
        cacharro_type: `cacharro_mobile`,
        media_url: preload_assets.videos.kaleidos,
        title: `kaleidOS`,
        description: `Multiplayer urban escape room in development made in Flutter.<br />Live a first person adventure while exploring the city as you never did before.`,
        tags: [`Indie Dev`, `Mobile Games`, `Urban Escape Room`, `Flutter`],
        links: []
    },
    {
        // 🟡: repasar el texto y video
        video_key: `gamejams_popurri`,
        cacharro_type: `cacharro_laptop`,
        media_url: preload_assets.videos.gamejams_popurri,
        title: `Game Jams`,
        description: `Some of the games I've made in game jams.`,
        tags: [`<span style="font-size: 0.9em">Unity</span>`, `<span style="font-size: 0.9em">Godot</span>`],
        links: [
            {
                type: `<span style="font-size: 0.9em">Game Bug</span>`,
                url: `https://le-slo.itch.io/game-bug-color`
            },
            {
                type: `<span style="font-size: 0.9em">Marzanna</span>`,
                url: `https://le-slo.itch.io/marzanna`
            },
            {
                type: `<span style="font-size: 0.9em">Republic Darkness</span>`,
                url: `https://drnlab.itch.io/republic-of-darkness`
            },
            {
                type: `<span style="font-size: 0.9em">6 Chambers Dice</span>`,
                url: `https://taletronic.itch.io/6-chambers-of-dice`
            },
        ]
    },

    // non used

    // {
    //     // 🟡: repasar el texto y video
    //     cacharro_type: `cacharro_switch`,
    //     media_url: `/media/ifo-hb.mp4`,
    //     title: `IFO`,
    //     description: `A spaceship simulator for aliens, an ever-changing rule discovery puzzle for humans.`,
    //     tags: [`Game`, `Puzzle`, `Escape Room`, `Unity`],
    //     links: [
    //         {
    //             type: `steam`,
    //             url: `https://store.steampowered.com/app/1876000/IFO/`
    //         }
    //     ]
    // },

    // {
    //     // 🟡: repasar el text y video, soe cropea
    //     cacharro_type: `cacharro_switch`,
    //     media_url: `/media/quiz-hb.mp4`,
    //     title: `Quiz 4 All`,
    //     description: `Use your knowledge and challenge your friends to play this fun quiz party game.`,
    //     tags: [`Game`, `Party Game`, `Unity`],
    //     links: [
    //         {
    //             type: `switch`,
    //             url: `https://www.nintendo.com/us/store/products/quiz-4-all-switch/`
    //         }
    //     ]
    // },
]

const contact_links = {
    linkedin: `https://www.linkedin.com/in/fernandogcat`,
    github: `https://github.com/fernandogcat`,
    bluesky: `https://bsky.app/profile/fernandog.cat`,
    linktree: `https://linktr.ee/fernandog.cat`,
    instagram: `https://www.instagram.com/fernandog.cat`,
}

export { bio, experiences, preload_assets, contact_links }